module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page department-staff-management"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "page-left-wrap"
  }, [_c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v("Department Management")]), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddDepartmentPop()
      }
    }
  }, [_vm._v("Add department")])], 1)]), _vm._v(" "), _c('el-tree', {
    attrs: {
      "data": _vm.tree.data,
      "props": _vm.tree.prop,
      "expand-on-click-node": false,
      "highlight-current": true,
      "default-expand-all": true,
      "render-content": _vm.renderTreeItemContent
    },
    on: {
      "node-click": _vm.clickmoduleTree
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "page-right-wrap"
  }, [(_vm.tree.current) ? _c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v(_vm._s(_vm.tree.current.OgName))]), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddStaffPop()
      }
    }
  }, [_vm._v("Add Staff")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "result-table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "AuName",
      "label": "Member Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OrganizationName",
      "label": "Department"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Roll Group"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row._LbNamelist), function(item, idx) {
          return _c('el-tag', {
            key: idx,
            staticStyle: {
              "margin-right": "5px"
            },
            attrs: {
              "type": "primary"
            }
          }, [_vm._v(_vm._s(item))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "AVAILABLE",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row._AuIsused) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("AVAILABLE")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("NO AVAILABLE")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "OPERATE",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "split-button": "",
            "size": "small",
            "type": "primary"
          },
          on: {
            "command": function($event) {
              return _vm.handleTableCommand($event, scope.$index, scope.row)
            },
            "click": function($event) {
              return _vm.showUpdateStaffPop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("\n                      Edit\n                      "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": "showAddPowerPop"
          }
        }, [_vm._v("Limit")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "showResetPasswordPop"
          }
        }, [_vm._v("Reset Password")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "delStaff"
          }
        }, [_vm._v("delete")])], 1)], 1)]
      }
    }])
  })], 1)], 1)])])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Department",
      "visible": _vm.departmentPop.show,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.departmentPop, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "pageForm",
    staticClass: "pop-form-wrap w400",
    attrs: {
      "model": _vm.departmentPop.data,
      "label-width": "80px"
    }
  }, [(!_vm.departmentPop.data.Id) ? _c('el-form-item', {
    attrs: {
      "label": "Superior Department",
      "prop": "Id"
    }
  }, [_c('tree-select', {
    attrs: {
      "treeData": _vm.tree.data,
      "treeProps": _vm.tree.prop,
      "multiple": false,
      "placeholder": "Please Select Department"
    },
    on: {
      "errorCallback": _vm.showTreeError,
      "setSelectedId": _vm.setSelectedId
    },
    model: {
      value: (_vm.departmentPop.data.Id),
      callback: function($$v) {
        _vm.$set(_vm.departmentPop.data, "Id", $$v)
      },
      expression: "departmentPop.data.Id"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "OgName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.departmentPop.data.OgName),
      callback: function($$v) {
        _vm.$set(_vm.departmentPop.data, "OgName", $$v)
      },
      expression: "departmentPop.data.OgName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer pop-center-btn-wrap",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.departmentPop.show = false
      }
    }
  }, [_vm._v("Canel")]), _vm._v(" "), (!_vm.departmentPop.data.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDepartment
    }
  }, [_vm._v("Add")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateDepartment
    }
  }, [_vm._v("determine")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Staff",
      "visible": _vm.staffPop.show,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.staffPop, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "pageForm",
    staticClass: "pop-form-wrap w400",
    attrs: {
      "model": _vm.staffPop.data,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "AuName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.staffPop.data.AuName),
      callback: function($$v) {
        _vm.$set(_vm.staffPop.data, "AuName", $$v)
      },
      expression: "staffPop.data.AuName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Account",
      "prop": "AuAccount"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.staffPop.data.AuAccount),
      callback: function($$v) {
        _vm.$set(_vm.staffPop.data, "AuAccount", $$v)
      },
      expression: "staffPop.data.AuAccount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Post",
      "prop": "AuPost"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.staffPop.data.AuPost),
      callback: function($$v) {
        _vm.$set(_vm.staffPop.data, "AuPost", $$v)
      },
      expression: "staffPop.data.AuPost"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile",
      "prop": "AuMobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.staffPop.data.AuMobile),
      callback: function($$v) {
        _vm.$set(_vm.staffPop.data, "AuMobile", $$v)
      },
      expression: "staffPop.data.AuMobile"
    }
  })], 1), _vm._v(" "), (!_vm.staffPop.data.Id) ? _c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "AuPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.staffPop.data.AuPassword),
      callback: function($$v) {
        _vm.$set(_vm.staffPop.data, "AuPassword", $$v)
      },
      expression: "staffPop.data.AuPassword"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Roll Group"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.currentLbNameList),
      callback: function($$v) {
        _vm.currentLbNameList = $$v
      },
      expression: "currentLbNameList"
    }
  }, _vm._l((_vm.LabelList), function(item, idx) {
    return _c('el-checkbox', {
      key: idx,
      attrs: {
        "label": item.LbName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer pop-center-btn-wrap",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.staffPop.show = false
      }
    }
  }, [_vm._v("Canel")]), _vm._v(" "), (!_vm.staffPop.data.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addStaff
    }
  }, [_vm._v("Add")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateStaff
    }
  }, [_vm._v("determine")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Give permission",
      "visible": _vm.powerPop.show,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.powerPop, "show", $event)
      }
    }
  }, [_c('PowerForm', {
    ref: "powerForm",
    on: {
      "updatePowerSuccess": _vm.updatePowerSuccess
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "ResetPassword",
      "visible": _vm.passwordPop.show,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.passwordPop, "show", $event)
      }
    }
  }, [_c('PasswordForm', {
    ref: "passwordForm",
    on: {
      "updateSuccess": _vm.updatePasswordSuccess
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-bar cfa"
  }, [_c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Department Staff Management")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1ba7a05a","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/system/DepartmentStaffManagement.vue
// module id = 738
// module chunks = 1